import { render, staticRenderFns } from "./ComingSoonMain.view.vue?vue&type=template&id=491b8bba&"
import script from "./ComingSoonMain.view.vue?vue&type=script&lang=js&"
export * from "./ComingSoonMain.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports